import { PagedList } from 'core/models/paged-list.model';
import { PromotionalProcessList, PromotionalProcessItem } from './promotionalProcess.model';

export const PROMOTIONAL_PROCESS_DUMMY_DATA: PagedList<PromotionalProcessList> = {
  items: [
    {
      id: 2,
      code: 'C',
      name: 'Cerveza',
      planningDays: 0,
      minimumCoverage: 0.4,
      customFields: [
        {
          groupName: 'Tipos de promociones',
          name: 'Mecanicas especiales',
          type: 'Text',
          regex: null,
          validationHint: '',
          isMandatory: false,
          requireSpecialPermission: false,
          listValues: 'P - Venta sugerida|I - Promopack Servicios|M - Medio de pago|L - Lealtad|S - Sinergia',
        },
      ],
      inUse: true,
      taskQuantity: 19,
    },
    {
      id: 3,
      code: 'CV',
      name: 'Corta Vigencia',
      planningDays: 0,
      minimumCoverage: 0.7,
      customFields: [
        {
          groupName: 'Tipos de promociones',
          name: 'Mecanicas especiales',
          type: 'Text',
          regex: null,
          validationHint: '',
          isMandatory: false,
          requireSpecialPermission: false,
          listValues: 'P - Venta sugerida|I - Promopack Servicios|M - Medio de pago|L - Lealtad|S - Sinergia',
        },
      ],
      inUse: false,
      taskQuantity: 0,
    },
    {
      id: 6,
      code: 'REAC',
      name: 'De reacción',
      planningDays: 0,
      minimumCoverage: 0.7,
      customFields: [
        {
          groupName: 'Tipos de promociones',
          name: 'Mecanicas especiales',
          type: 'Text',
          regex: null,
          validationHint: '',
          isMandatory: false,
          requireSpecialPermission: false,
          listValues: 'P - Venta sugerida|I - Promopack Servicios|M - Medio de pago|L - Lealtad|S - Sinergia',
        },
      ],
      inUse: false,
      taskQuantity: 0,
    },
    {
      id: 4,
      code: 'LE',
      name: 'Lealtad',
      planningDays: 0,
      minimumCoverage: 0.7,
      customFields: [
        {
          groupName: 'Tipos de promociones',
          name: 'Mecanicas especiales',
          type: 'Text',
          regex: null,
          validationHint: '',
          isMandatory: false,
          requireSpecialPermission: false,
          listValues: 'P - Venta sugerida|I - Promopack Servicios|M - Medio de pago|L - Lealtad|S - Sinergia',
        },
      ],
      inUse: false,
      taskQuantity: 0,
    },
    {
      id: 5,
      code: 'LOC',
      name: 'Locales',
      planningDays: 0,
      minimumCoverage: 0.7,
      customFields: [
        {
          groupName: 'Tipos de promociones',
          name: 'Mecanicas especiales',
          type: 'Text',
          regex: null,
          validationHint: '',
          isMandatory: false,
          requireSpecialPermission: false,
          listValues: 'P - Venta sugerida|I - Promopack Servicios|M - Medio de pago|L - Lealtad|S - Sinergia',
        },
      ],
      inUse: false,
      taskQuantity: 0,
    },
    {
      id: 1,
      code: 'NAC',
      name: 'Nacionales',
      planningDays: 0,
      minimumCoverage: 0.85,
      customFields: [
        {
          groupName: 'Tipos de promociones',
          name: 'Mecanicas especiales',
          type: 'Text',
          regex: null,
          validationHint: '',
          isMandatory: false,
          requireSpecialPermission: false,
          listValues: 'P - Venta sugerida|I - Promopack Servicios|M - Medio de pago|L - Lealtad|S - Sinergia',
        },
      ],
      inUse: true,
      taskQuantity: 19,
    },
    {
      id: 7,
      code: 'PQA',
      name: 'Prisma-QA',
      planningDays: 0,
      minimumCoverage: 0.0,
      customFields: [
        {
          groupName: 'Tipos de promociones',
          name: 'Mecanicas especiales',
          type: 'Text',
          regex: null,
          validationHint: '',
          isMandatory: false,
          requireSpecialPermission: false,
          listValues: 'P - Venta sugerida|I - Promopack Servicios|M - Medio de pago|L - Lealtad|S - Sinergia',
        },
      ],
      inUse: false,
      taskQuantity: 2,
    },
  ],
  totalItemCount: 7,
  pageIndex: 0,
  pageSize: 10,
};

export const PROMOTIONAL_PROCESS_ITEM_DUMMY_DATA: PromotionalProcessItem = {
  id: 1,
  code: 'N',
  name: 'Nacional',
  inUse: false,
  minimumCoverage: 85,
  tasks: [
    {
      id: 1,
      name: 'Inicia actualización Inventario Espacios',
      startingDay: 30,
      taskOwners: { roles: [{ id: '94b4d923-4e68-a4bf-b2a8-96c0399c71a5', name: 'asdasd' }], users: [] },
      consultants: { roles: [{ id: '94b4d923-4e68-a4bf-b2a8-96c0399c71a5', name: 'prisma_qa' }], users: [] },
      durationInDays: 5,
      requiresCompletion: true,
      actionables: null,
    },
    {
      id: 3,
      name: 'Inicio de analisis de promociones sugeridas',
      startingDay: 30,
      taskOwners: {
        roles: [
          {
            id: '94b4d923-4e68-a4bf-b2a8-96c0399c71a5',
            name: 'prisma_qa',
          },
          {
            id: 'e2d252eb-abb2-4ed8-8876-7166c579b3c2',
            name: 'Prueba permisos promociones',
          },
          {
            id: '002878c6-00ce-4d6a-a62c-90e9af015a46',
            name: 'admin',
          },
        ],
        users: [],
      },
      consultants: {
        roles: [
          {
            id: '94b4d923-4e68-a4bf-b2a8-96c0399c71a5',
            name: 'prisma_qa',
          },
          {
            id: 'e2d252eb-abb2-4ed8-8876-7166c579b3c2',
            name: 'Prueba permisos promociones',
          },
          {
            id: '002878c6-00ce-4d6a-a62c-90e9af015a46',
            name: 'admin',
          },
        ],
        users: [],
      },
      durationInDays: 5,
      requiresCompletion: true,
      actionables: null,
    },
    {
      id: 4,
      name: 'Kuona carga información de analisis mecanicas promocionales',
      startingDay: 30,
      taskOwners: { roles: [{ id: 'c513c8cb-b033-41d6-a884-69902237881c', name: 'Categoria' }], users: [] },
      consultants: { roles: [{ id: 'c513c8cb-b033-41d6-a884-69902237881c', name: 'Categoria' }], users: [] },
      durationInDays: 5,
      requiresCompletion: true,
      actionables: null,
    },

    {
      id: 2,
      name: 'Definción de mecanicas con proveedor',
      startingDay: -20,
      taskOwners: { roles: [{ id: 'c513c8cb-b033-41d6-a884-69902237881c', name: 'Categoria' }], users: [] },
      consultants: { roles: [{ id: 'c513c8cb-b033-41d6-a884-69902237881c', name: 'Categoria' }], users: [] },
      durationInDays: 5,
      requiresCompletion: false,
      actionables: null,
    },
  ],
};
